module.exports = __webpack_public_path__ + "assets/img/worldviewImgActive-342aa8a7.png";